<template>
  <footer class="footer px-4 mx-2 app-footer">
    <div class="row align-items-center justify-content-lg-between">
  
      <div class="col-lg-12">
        <div class="copyright">
          Version: {{ frontVersion }}
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import pkg from '../../package.json';
export default {
  data() {
    return {
      frontVersion: pkg.version || '',
    };
  },
};
</script>
<style scoped>
.app-footer {
  background: transparent !important;
}
.app-footer .copyright {
  color: #fff !important;
  text-align: center;
}
</style>
